import { from, concatMap, filter, tap } from 'rxjs'
import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { handleMessages, refreshToken } from '../../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    // 體驗金
    cannotBeReceiveExperienceMoneyMessage: null,
    experienceMoneyPlatforms: [],
    selectedExperienceMoneyPlatform: null,

    // 存送優惠
    saveAndSendPromotions: [],
    selectedSaveAndSendPromotion: null,
    transferPrice: null,

    // 自助返水
    selfHelpBackwaters: [],

    // 救援金
    rescueMoneys: [],

    // 優惠卷專區
    selectedVoucherType: null,
    voucherPlatforms: [],
    selectedVoucherPlatform: null,
    saveAndSendVoucherPrice: null,
    saveAndSendVoucherCode: null,
    redBagVoucherCode: null,

    // 生日禮金
    cannotBeReceiveBirthdayGiftMoneyMessage: null,
    canBeReceiveRemainDays: null, // 可領取生日禮金的剩餘天數
    canBeReceiveRemainDaysMessage: null, // 可領取生日禮金的剩餘天數顯示訊息
    canBeReceiveBirthdayGiftMoney: null, // 可領取生日禮金的金額

    // 簽到禮金
    checkInRecords: [],
    checkInErrorCategory: null,
    checkInErrorMessage: null,

    // My Bonus
    myBonusList: []
  }),
  actions: {
    // 簽到彈窗資料
    getCheckInRecords(context) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/signRecordForCycle`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('CHECK_IN_RECORDS', data.signRecords)
          })
        )
        .toPromise()
    },
    checkIn(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/simpleApply`,
                {
                  youhuiCode: 'SIGN'
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getPromotionPlatforms(context, payload) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$get(
                `/webapi/youhui/platform/${payload}`,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    checkCanBeReceiveExperienceMoney(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/freeCash/check`,
                {},
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    receiveExperienceMoney(context) {
      const { state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/freeCash/apply`,
                {
                  platform: state.selectedExperienceMoneyPlatform
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getSaveAndSendPromotions(context) {
      const { commit, rootState, state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/deposit/query`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('SAVE_AND_SEND_PROMOTIONS', data)
            // 錢包以有自助存送優惠的來顯示
            commit(
              'userModule/WALLETS',
              rootState.userModule.wallets.filter(wallet =>
                state.saveAndSendPromotions.some(
                  saveAndSendPromotion =>
                    wallet === saveAndSendPromotion.platform
                )
              ),
              { root: true }
            )
          })
        )
        .toPromise()
    },
    applySelfHelpSaveAndSend(context) {
      const { state } = context
      const selectedSaveAndSendPromotion = state.saveAndSendPromotions.find(
        saveAndSendPromotion =>
          state.selectedSaveAndSendPromotion === saveAndSendPromotion.id
      )
      const data = {
        remit: state.transferPrice,
        youHuiType: selectedSaveAndSendPromotion.title,
        youhuiConfigId: selectedSaveAndSendPromotion.id
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/deposit/apply`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    applyVoucher(context) {
      const { state } = context
      if (state.selectedVoucherType === 'save-and-send') {
        const data = {
          couponCode: state.saveAndSendVoucherCode,
          couponRemit: state.saveAndSendVoucherPrice,
          couponType: state.selectedVoucherPlatform
        }

        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/youhui/coupon/apply`,
                  data,
                  getAxiosConfig(context)
                )
              )
            )
          )
          .toPromise()
      } else {
        const data = {
          couponType: state.selectedVoucherPlatform,
          hongbaoCode: state.redBagVoucherCode
        }
        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/youhui/hongbao/apply`,
                  data,
                  getAxiosConfig(context)
                )
              )
            )
          )
          .toPromise()
      }
    },
    getSelfHelpBackwaters(context) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/xima/v2/getAllAutoXimaObject`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('SELF_HELP_BACKWATERS', data)
          })
        )
        .toPromise()
    },
    applySelfHelpBackwater(context, payload) {
      const data = {
        platform: payload
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/xima/doXima`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getRescueMoneys(context) {
      const { commit } = context
      const data = {
        date: '1'
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/lose/query`,
                data,
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('RESCUE_MONEYS', data)
          })
        )
        .toPromise()
    },
    applyRescueMoney(context, payload) {
      const data = {
        pno: payload
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/lose/apply`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    checkCanBeReceiveBirthdayGiftMoney(context) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/simpleCheck/BIRTHDAY`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('CAN_BE_RECEIVE_BIRTHDAY_GIFT_MONEY', data.money)
          })
        )
        .toPromise()
    },
    getCanBeReceiveRemainDays({ commit }, payload) {
      const thisBirthday = this.$dayjs(payload, 'YYYY-MM-DD').set(
        'year',
        this.$dayjs().get('year')
      )
      let range
      let days
      if (this.$dayjs().isAfter(thisBirthday)) {
        range = thisBirthday.add(1, 'years').diff(this.$dayjs(), 'day')
        days = range + 1 === 365 ? 0 : range + 1
      } else {
        range = this.$dayjs().diff(thisBirthday, 'day')
        days = range - 1 === 365 ? 0 : range - 1
      }
      commit('CAN_BE_RECEIVE_REMAIN_DAYS', Math.abs(days))
    },
    receiveBirthdayGiftMoney(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/simpleApply`,
                {
                  youhuiCode: 'BIRTHDAY'
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getMyBonusList(context) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/findUnlockCoupons`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('MY_BONUS_LIST', data)
          })
        )
        .toPromise()
    },
    getMyBonusProgress(context, payload) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/youhui/getCouponProgress?pno=${payload}`,
                {},
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    }
  },
  mutations: {
    CANNOT_BE_RECEIVE_EXPERIENCE_MONEY_MESSAGE(state, payload) {
      state.cannotBeReceiveExperienceMoneyMessage = payload
    },
    EXPERIENCE_MONEY_PLATFORMS(state, payload) {
      state.experienceMoneyPlatforms = payload
    },
    SELECTED_EXPERIENCE_MONEY_PLATFORM(state, payload) {
      state.selectedExperienceMoneyPlatform = payload
    },

    SAVE_AND_SEND_PROMOTIONS(state, payload) {
      state.saveAndSendPromotions = payload
    },
    SELECTED_SAVE_AND_SEND_PROMOTION(state, payload) {
      state.selectedSaveAndSendPromotion = payload
    },
    TRANSFER_PRICE(state, payload) {
      state.transferPrice = payload
    },

    SELF_HELP_BACKWATERS(state, payload) {
      state.selfHelpBackwaters = payload
    },

    RESCUE_MONEYS(state, payload) {
      state.rescueMoneys = payload
    },

    SELECTED_VOUCHER_TYPE(state, payload) {
      state.selectedVoucherType = payload
    },
    VOUCHER_PALTFORMS(state, payload) {
      state.voucherPlatforms = payload
    },
    SELECTED_VOUCHER_PLATFORM(state, payload) {
      state.selectedVoucherPlatform = payload
    },
    SAVE_AND_SEND_VOUCHER_PRICE(state, payload) {
      state.saveAndSendVoucherPrice = payload
    },
    SAVE_AND_SEND_VOUCHER_CODE(state, payload) {
      state.saveAndSendVoucherCode = payload
    },
    RED_BAG_VOUCHER_CODE(state, payload) {
      state.redBagVoucherCode = payload
    },

    CANNOT_BE_RECEIVE_BIRTHDAY_GIFT_MONEY_MESSAGE(state, payload) {
      state.cannotBeReceiveBirthdayGiftMoneyMessage = payload
    },
    CAN_BE_RECEIVE_REMAIN_DAYS(state, payload) {
      state.canBeReceiveRemainDays = payload
    },
    CAN_BE_RECEIVE_REMAIN_DAYS_MESSAGE(state, payload) {
      state.canBeReceiveRemainDaysMessage = payload
    },
    CAN_BE_RECEIVE_BIRTHDAY_GIFT_MONEY(state, payload) {
      state.canBeReceiveBirthdayGiftMoney = payload
    },
    BIRTHDAY_GIFT_MONEY_PLATFORMS(state, payload) {
      state.birthdayGiftMoneyPlatforms = payload
    },

    CHECK_IN_RECORDS(state, payload) {
      state.checkInRecords = payload
    },
    CHECK_IN_ERROR_CATEGORY(state, payload) {
      state.checkInErrorCategory = payload
    },
    CHECK_IN_ERROR_MESSAGE(state, payload) {
      state.checkInErrorMessage = payload
    },

    MY_BONUS_LIST(state, payload) {
      state.myBonusList = payload
    }
  },
  getters: {
    experienceMoneyPlatforms: state => state.experienceMoneyPlatforms,
    selectedExperienceMoneyPlatform: state =>
      state.selectedExperienceMoneyPlatform,

    saveAndSendPromotions: state => state.saveAndSendPromotions,
    selectedSaveAndSendPromotion: state => state.selectedSaveAndSendPromotion,
    transferPrice: state => state.transferPrice,

    selfHelpBackwaters: state => state.selfHelpBackwaters,

    rescueMoneys: state => state.rescueMoneys,

    selectedVoucherType: state => state.selectedVoucherType,
    voucherPlatforms: state => state.voucherPlatforms,
    selectedVoucherPlatform: state => state.selectedVoucherPlatform,
    saveAndSendVoucherPrice: state => state.saveAndSendVoucherPrice,
    saveAndSendVoucherCode: state => state.saveAndSendVoucherCode,
    redBagVoucherCode: state => state.redBagVoucherCode,

    cannotBeReceiveBirthdayGiftMoneyMessage: state =>
      state.cannotBeReceiveBirthdayGiftMoneyMessage,
    canBeReceiveRemainDays: state => state.canBeReceiveRemainDays,
    canBeReceiveRemainDaysMessage: state => state.canBeReceiveRemainDaysMessage,
    canBeReceiveBirthdayGiftMoney: state => state.canBeReceiveBirthdayGiftMoney,

    checkInRecords: state => state.checkInRecords,
    checkInErrorCategory: state => state.checkInErrorCategory,
    checkInErrorMessage: state => state.checkInErrorMessage,

    myBonusList: state => state.myBonusList
  }
}
